import React from "react";
import { shallowEqual } from "react-redux";
import { type UscDispatchType, useUscSelector } from "../../../redux/store";
import { getMobileFooterCta } from "../../../utils/ctaUtils";
import { UscNavStepEnum } from "../../../utils/constants";
import { showModal } from "../../../../../common-deprecated/redux/actions/ModalActions";
import { MODAL_USC_BASKET_DETAILS, MODAL_USC_DISCOVER_YOUR_CAR } from "../../../utils/modalConstants";
import { UscLabel } from "../../../utils/labels";
import useNavParams from "../../../hooks/useNavParams";
import * as Styles from "./MobileFooter.styles";
import Button from "../../../../shared-components/lexus/styles/atoms/Button";
import Text from "../../../../shared-components/lexus/styles/atoms/Text";
import Icon from "../../../../shared-components/lexus/styles/atoms/Icon";
import {
    trackDiscoverYourCarModalOpen,
    trackOpenBasketDetailsModal,
    UscTrackingLocation,
} from "../../../utils/tracking";
import { pdpSectionSelector } from "../../../utils/pdpUtils";
import { useDispatch } from "../../../../../shared-logic/redux/store";

const MobileFooter = (): JSX.Element => {
    const dispatch = useDispatch<UscDispatchType>();

    const step = useUscSelector((state) => state.nav.step);
    const vehicleType = useUscSelector((state) => state.vehicle.type);
    const visiblePdpSections = useUscSelector(pdpSectionSelector, shallowEqual);
    const navParams = useNavParams(UscTrackingLocation.Footer);

    const mobileFooterCta = getMobileFooterCta(navParams);

    return (
        <Styles.Wrapper>
            <Styles.Body>
                {mobileFooterCta && (
                    <Button
                        variant="primary"
                        size="fullwidth"
                        href={mobileFooterCta.href ? mobileFooterCta.href : undefined}
                        onClick={mobileFooterCta.onClick}
                        rel={mobileFooterCta.rel}
                    >
                        {mobileFooterCta.label}
                    </Button>
                )}
            </Styles.Body>

            {step === UscNavStepEnum.Pdp ? (
                // Only show the discover your car modal when we have at least 2 results
                visiblePdpSections.length >= 2 && (
                    <Styles.Toggle
                        type="button"
                        onClick={() => {
                            dispatch(showModal({ type: MODAL_USC_DISCOVER_YOUR_CAR }));
                            trackDiscoverYourCarModalOpen(vehicleType);
                        }}
                    >
                        <Text variant="paragraph-small-regular" color="midnight">
                            <UscLabel label="uscDiscoverYourCar" />
                        </Text>
                        <Icon variant="chevron-up" />
                    </Styles.Toggle>
                )
            ) : (
                <Styles.Toggle
                    type="button"
                    onClick={() => {
                        trackOpenBasketDetailsModal(UscTrackingLocation.Footer, vehicleType);
                        dispatch(showModal({ type: MODAL_USC_BASKET_DETAILS }));
                    }}
                >
                    <Text variant="paragraph-small-regular" color="midnight">
                        <UscLabel label="uscBasketCtaBasketDetails" />
                    </Text>
                    <Icon variant="basket-variant" />
                </Styles.Toggle>
            )}
        </Styles.Wrapper>
    );
};

export default MobileFooter;
